import React from 'react';
//import { Helmet } from "react-helmet-async";
import { Helmet } from "react-helmet-async";

const MetaComponent = ({
  keywords,
  description,
  ogTitle,
  ogDescription,
  ogUrl,
  ogImage,
  twitterTitle,
  twitterDescription,
  twitterUrl,
  twitterImage,
  canonicalUrl
}: any) => {

  return (
    <Helmet>

      <link rel="canonical" href={canonicalUrl} />
      <title>{ogTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      <meta property="og:type" content="website" />
      <meta id="og-title" property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:image" content={ogImage} />
      {twitterTitle && <meta property="twitter:title" content={twitterTitle} />}
      {twitterDescription && <meta property="twitter:description" content={twitterDescription} />}
      {twitterUrl && <meta property="twitter:url" content={twitterUrl} />}
      {twitterImage && <meta property="twitter:image" content={twitterImage} />}
      <meta name="copyright" content="Great Nonprofits 2007-2024" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta httpEquiv="X-XRDS-Location" content="https://qa.greatnonprofits.org/openid/yadis" />
      <meta content="X-Content-Security-Policy-Report-Only: default-src 'self'" />

    </Helmet>
  );
};

export default MetaComponent;

// import React from 'react'
// import { Helmet } from "react-helmet-async";

// const MetaComponent = ({ keywords, description, ogTitle, ogDescription, ogUrl, ogImage }: any) => {
//   console.log("heowepwe", ogTitle, ogDescription)
//   return (
//     <Helmet>
//       <title>{ogTitle}</title>
//       <meta name="description" content={description} />
//       <meta name="keywords" content={keywords} />
//       <meta property="og:type" content="website" />
//       <meta property="og:title" content={ogTitle} />
//       <meta property="og:description" content={ogDescription} />
//       <meta property="og:url" content={ogUrl} />
//       <meta property="og:image" content={ogImage}></meta>
//       <meta name="copyright" content="Great Nonprofits 2007-2024"></meta>
//       <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
//       <meta httpEquiv="X-XRDS-Location" content="https://qa.greatnonprofits.org/openid/yadis"></meta>
//       <meta content="X-Content-Security-Policy-Report-Only: default-src 'self'"></meta>

//     </Helmet>
//   )
// }

// export default MetaComponent